<template>
  <AppLayout
    :full-width="true"
    :body-class="['overflow-hidden', 'an-u-min-h-100vh']"
  >
    <div
      v-if="video"
      class="relative bg-black"
      style="height: 100vh; width: 100vw"
    >
      <VideoPlayer
        v-if="(video.userId || video.userUid) && video.blobName"
        :video="video"
        class="video-player-wrapper"
        :class="{ 'drawer-visible': isDrawerVisible }"
        hide-back-button
      />
      <div
        v-if="isFloatingMenuVisible"
        class="fixed left-1/2 opacity-100 transition-[bottom]"
        :class="{
          'floating-with-drawer': isDrawerVisible,
          'bottom-32': isImageSliderVisible,
          'bottom-12': !isImageSliderVisible,
        }"
      >
        <FloatingMenu absolute>
          <ContextCard position="bottom-center">
            <CogIcon class="h-5 w-5" />
            <template #content>
              <VideoSettings
                :playback-rate="playbackRate"
                @change="setPlaybackRate"
              />
            </template>
          </ContextCard>
          <button
            type="button"
            class="cursor-pointer p-2 font-bold transition-colors"
            :class="{ 'text-gray-400': !isPoseDetectorInitialized }"
            :disabled="!isPoseDetectorInitialized"
            @click="toggleVideoAI"
          >
            <svg
              class="h-5 w-5"
              viewBox="0 0 200 200"
              fill="currentColor"
              stroke="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M78.36 169.26C68.9733 169.26 60.2467 166.913 52.18 162.22C44.1133 157.527 37.7333 151.22 33.04 143.3C28.3467 135.233 26 126.58 26 117.34C26 108.1 28.3467 99.52 33.04 91.6C37.7333 83.5333 44.1133 77.1533 52.18 72.46C60.2467 67.7667 68.9733 65.42 78.36 65.42C87.8933 65.42 96.9133 67.9867 105.42 73.12C113.927 78.1067 119.867 84.6333 123.24 92.7V67.84H130.28V166.84H123.24V142.2C119.28 150.413 113.12 157.013 104.76 162C96.5467 166.84 87.7467 169.26 78.36 169.26ZM78.8 163.1C86.8667 163.1 94.3467 161.047 101.24 156.94C108.133 152.687 113.56 147.113 117.52 140.22C121.627 133.18 123.68 125.553 123.68 117.34C123.68 109.273 121.627 101.72 117.52 94.68C113.413 87.64 107.913 82.0667 101.02 77.96C94.1267 73.7067 86.6467 71.58 78.58 71.58C70.5133 71.58 62.96 73.7067 55.92 77.96C49.0267 82.2133 43.4533 87.86 39.2 94.9C35.0933 101.94 33.04 109.493 33.04 117.56C33.04 125.627 35.0933 133.18 39.2 140.22C43.4533 147.113 49.1 152.687 56.14 156.94C63.18 161.047 70.7333 163.1 78.8 163.1Z"
              />
              <path
                d="M166.628 45.18C164.575 45.18 162.741 44.4467 161.128 42.98C159.661 41.5133 158.928 39.68 158.928 37.48C158.928 35.4267 159.661 33.6667 161.128 32.2C162.741 30.7333 164.575 30 166.628 30C168.681 30 170.441 30.7333 171.908 32.2C173.521 33.6667 174.328 35.4267 174.328 37.48C174.328 39.68 173.521 41.5133 171.908 42.98C170.441 44.4467 168.681 45.18 166.628 45.18ZM163.108 67.84H170.148V166.84H163.108V67.84Z"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M26.1413 147.351L26.1252 147.323C20.7286 138.048 18 128.008 18 117.34C18 106.681 20.7243 96.7013 26.1411 87.5495C31.5302 78.2975 38.9012 70.9303 48.1569 65.5452C57.4526 60.1368 67.5686 57.42 78.36 57.42C89.3968 57.42 99.8236 60.4089 109.51 66.2446C111.531 67.4316 113.443 68.7053 115.24 70.0661V59.84H138.28V174.84H115.24V164.501C113.243 166.068 111.115 167.525 108.858 168.871L108.84 168.881L108.822 168.892C99.3978 174.446 89.1984 177.26 78.36 177.26C67.5686 177.26 57.4526 174.543 48.1569 169.135C38.9278 163.765 31.5565 156.489 26.1577 147.378L26.1413 147.351ZM123.24 166.84H130.28V67.84H123.24V92.7C123.088 92.3364 122.931 91.9759 122.768 91.6186C122.61 91.2715 122.448 90.9274 122.28 90.5862C120.493 86.9487 118.146 83.6467 115.24 80.6802C112.474 77.856 109.2 75.336 105.42 73.12C105.075 72.912 104.73 72.7083 104.384 72.5087C104.355 72.4921 104.326 72.4756 104.297 72.459C96.1865 67.8041 87.6141 65.4579 78.58 65.4205C78.5067 65.4202 78.4334 65.42 78.36 65.42C69.0931 65.42 60.4695 67.7071 52.4892 72.2814C52.4712 72.2917 52.4533 72.3021 52.4353 72.3124C52.3501 72.3613 52.265 72.4105 52.18 72.46C44.2174 77.0928 37.8983 83.369 33.2225 91.2886C33.2043 91.3195 33.1861 91.3504 33.1679 91.3813C33.1251 91.4541 33.0825 91.527 33.04 91.6C28.3467 99.52 26 108.1 26 117.34C26 117.413 26.0001 117.487 26.0004 117.56C26.0374 126.717 28.3839 135.297 33.04 143.3C33.1154 143.427 33.1913 143.554 33.2676 143.681C33.2969 143.729 33.3262 143.778 33.3557 143.826C38.018 151.5 44.2928 157.631 52.18 162.22C52.3702 162.331 52.5608 162.44 52.7518 162.548C52.7811 162.565 52.8103 162.581 52.8397 162.598C60.7218 167.039 69.2286 169.26 78.36 169.26C78.5068 169.26 78.6535 169.259 78.8 169.258C87.8794 169.185 96.4077 166.838 104.385 162.219C104.413 162.203 104.44 162.187 104.468 162.171C104.565 162.114 104.663 162.057 104.76 162C108.756 159.616 112.249 156.864 115.24 153.744C118.021 150.841 120.368 147.62 122.28 144.08C122.428 143.806 122.574 143.529 122.717 143.251C122.723 143.239 122.729 143.228 122.735 143.216C122.907 142.88 123.075 142.541 123.24 142.2V166.84ZM118.1 139.198C119.957 135.826 121.35 132.323 122.28 128.687C123.213 125.038 123.68 121.256 123.68 117.34C123.68 113.494 123.213 109.765 122.28 106.153C121.32 102.436 119.865 98.8432 117.917 95.3736C117.849 95.2528 117.781 95.1322 117.712 95.0118C117.648 94.9011 117.584 94.7905 117.52 94.68C117.127 94.0066 116.722 93.3466 116.303 92.7C115.958 92.1657 115.603 91.6405 115.24 91.1245C111.707 86.1041 107.35 81.9514 102.169 78.6662C102.146 78.6515 102.123 78.6369 102.1 78.6224C101.744 78.3975 101.384 78.1767 101.02 77.96C94.1267 73.7067 86.6467 71.58 78.58 71.58C78.5066 71.58 78.4333 71.5802 78.36 71.5805C70.376 71.6189 62.896 73.7454 55.92 77.96C55.7874 78.0418 55.6553 78.1241 55.5237 78.207C48.8128 82.4311 43.3715 87.9954 39.2 94.9C39.1587 94.9707 39.1177 95.0415 39.0768 95.1124C39.0675 95.1285 39.0582 95.1447 39.0489 95.1609C35.0799 102.062 33.0771 109.455 33.0405 117.34C33.0402 117.413 33.04 117.487 33.04 117.56C33.04 125.465 35.0116 132.876 38.9549 139.795C38.964 139.811 38.9731 139.827 38.9822 139.843C39.0541 139.969 39.1267 140.094 39.2 140.22C43.3207 146.898 48.7493 152.338 55.4857 156.538C55.7024 156.674 55.9205 156.807 56.14 156.94C63.0518 160.972 70.4585 163.025 78.36 163.098C78.5065 163.099 78.6532 163.1 78.8 163.1C86.8667 163.1 94.3467 161.047 101.24 156.94C101.362 156.864 101.484 156.789 101.606 156.712C101.615 156.706 101.624 156.701 101.634 156.695C107.11 153.248 111.645 148.954 115.24 143.813C115.61 143.284 115.969 142.747 116.319 142.2C116.733 141.553 117.134 140.893 117.52 140.22C117.638 140.017 117.755 139.814 117.87 139.611C117.947 139.473 118.024 139.336 118.1 139.198ZM97.0926 150.099C102.85 146.535 107.309 141.934 110.583 136.235L110.596 136.212L110.61 136.189C113.997 130.382 115.68 124.148 115.68 117.34C115.68 110.705 114.011 104.541 110.61 98.711C107.175 92.8222 102.636 88.2346 96.9256 84.8328L96.8721 84.801L96.8191 84.7683C91.183 81.2907 85.1565 79.58 78.58 79.58C72.0133 79.58 65.8967 81.2863 60.0884 84.7883C54.3263 88.3505 49.6747 93.0507 46.0793 98.984C42.6994 104.798 41.04 110.945 41.04 117.56C41.04 124.162 42.6932 130.299 46.0605 136.103C49.6188 141.842 54.3087 146.476 60.2243 150.061C66.0384 153.441 72.1854 155.1 78.8 155.1C85.4126 155.1 91.4596 153.442 97.0926 150.099ZM155.606 48.7715L155.471 48.6369C152.406 45.5718 150.928 41.6589 150.928 37.48C150.928 33.2808 152.521 29.493 155.471 26.5431L155.606 26.4085L155.747 26.2805C158.733 23.5657 162.454 22 166.628 22C170.763 22 174.499 23.5449 177.429 26.4086C180.509 29.2719 182.328 33.0861 182.328 37.48C182.328 41.8476 180.637 45.7872 177.43 48.7706C174.5 51.6349 170.763 53.18 166.628 53.18C162.454 53.18 158.733 51.6143 155.747 48.8995L155.606 48.7715ZM161.128 32.2C162.741 30.7333 164.575 30 166.628 30C168.681 30 170.441 30.7333 171.908 32.2C173.521 33.6667 174.328 35.4267 174.328 37.48C174.328 39.68 173.521 41.5133 171.908 42.98C170.441 44.4467 168.681 45.18 166.628 45.18C164.575 45.18 162.741 44.4467 161.128 42.98C159.661 41.5133 158.928 39.68 158.928 37.48C158.928 35.4267 159.661 33.6667 161.128 32.2ZM155.108 59.84H178.148V174.84H155.108V59.84ZM170.148 166.84V67.84H163.108V166.84H170.148Z"
              />
            </svg>
          </button>
          <button
            class="cursor-pointer p-2"
            type="button"
            @click="toggleImageSlider"
          >
            <ArrowsUpDownIcon class="h-5 w-5" />
          </button>
        </FloatingMenu>
      </div>
    </div>
  </AppLayout>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import { ref, onMounted } from 'vue';
import { CogIcon, ArrowsUpDownIcon } from '@heroicons/vue/20/solid';
import { IVideo } from 'src/core/Interfaces/IVideo';
import { VITE_BFF_API_PATH } from 'src/core/ClientAppConfig';
import {
  CONTEXT_CARD_EVENTS,
  POSE_DETECTOR_EVENTS,
  VIDEO_EVENTS,
  VIDEO_PLAYER_EVENTS,
} from 'src/core/Events';
import { useEmitter } from 'src/core/EventEmitter';
import AppLayout from 'src/components/layout/AppLayout.vue';
import ContextCard from 'src/components/common/ContextCard.vue';
import FloatingMenu from 'src/components/common/FloatingMenu.vue';
import VideoPlayer from 'src/components/Video/VideoPlayer.vue';
import VideoSettings from 'src/components/Video/VideoSettings.vue';

const route = useRoute();
const emitter = useEmitter();
const video = ref<IVideo>({} as IVideo);
const videFetchError = ref(false);
const videoFetchInProgress = ref(false);
const isFloatingMenuVisible = ref(true);
const isDrawerVisible = ref(false);
const playbackRate = ref(1);
const isImageSliderVisible = ref(true);
const isPoseDetectorInitialized = ref(false);

emitter.on(POSE_DETECTOR_EVENTS.INITIALIZED, () => {
  isPoseDetectorInitialized.value = true;
});

emitter.on(
  VIDEO_EVENTS.VIDEO_SEEK_START,
  () => (isFloatingMenuVisible.value = false),
);

emitter.on(
  VIDEO_EVENTS.VIDEO_SEEK_END,
  () => (isFloatingMenuVisible.value = true),
);

onMounted(async () => {
  videFetchError.value = false;
  videoFetchInProgress.value = true;

  const response = await fetch(
    `${VITE_BFF_API_PATH}/api/share/video/${route.params.videoId}`,
  );

  videoFetchInProgress.value = false;

  if (!response.ok) {
    videFetchError.value = true;

    return;
  }
  video.value = await response.json();
});

const toggleVideoAI = () => {
  emitter.emit(VIDEO_PLAYER_EVENTS.TOGGLE_VIDEO_AI);
};

const toggleImageSlider = () => {
  isImageSliderVisible.value = !isImageSliderVisible.value;
  emitter.emit(VIDEO_PLAYER_EVENTS.TOGGLE_IMAGE_SLIDER);
};

const setPlaybackRate = (value: unknown) => {
  playbackRate.value = Number(value);
  emitter.emit(VIDEO_EVENTS.CHANGE_PLAYBACKRATE, playbackRate.value);
  emitter.emit(CONTEXT_CARD_EVENTS.CLOSE);
};
</script>

<style scoped>
.floating-menu {
  bottom: 168px !important;
}

@media (orientation: landscape) {
  .floating-menu {
    bottom: calc(88px + (4.1 * env(safe-area-inset-bottom))) !important;
  }
}

.video-player-wrapper {
  height: 100vh;
  width: 100vw;
}

.drawer-visible {
  height: 50%;
}

.floating-with-drawer {
  bottom: 60%;
}

@screen sm {
  .drawer-visible {
    height: 100vh !important;
    width: 57vw !important;
  }

  .close-modal-icon {
    transform: rotate(-90deg);
  }

  .floating-with-drawer {
    bottom: 8rem;
    left: 33.3%;
  }
}

@screen lg {
  .drawer-visible {
    height: 100% !important;
    width: 67vw !important;
  }
}
</style>
